var _rect, _rect2, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _g2, _g3, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _rect3, _g4, _g5, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalancebg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 370,
    height: 161,
    viewBox: "0 0 370 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 21,
    width: 370,
    height: 140,
    rx: 16,
    fill: "#169560"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4249_4390",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 21,
    width: 370,
    height: 140
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 21,
    width: 370,
    height: 140,
    rx: 16,
    fill: "#169560"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4249_4390)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4249_4390",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -26,
    y: -24,
    width: 422,
    height: 245
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-25.4031 -23.7217H395.403V180.118C395.403 202.21 377.494 220.118 355.403 220.118H14.597C-7.49443 220.118 -25.4031 202.21 -25.4031 180.118V-23.7217Z",
    fill: "#5070DE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4249_4390)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-25.403 165.906L180.77 179.76L-25.403 140.492V165.906Z",
    fill: "url(#paint0_radial_4249_4390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.612 -105L112.623 -105L180.77 179.757L154.612 -105Z",
    fill: "url(#paint1_radial_4249_4390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.403 148.733L180.77 179.758L395.403 174.696V148.733Z",
    fill: "url(#paint2_radial_4249_4390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-25.4027 59.553L180.77 179.758L-25.4027 36.4717V59.553Z",
    fill: "url(#paint3_radial_4249_4390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.151 -105L180.77 179.757L395.403 -63.7624V-105H383.151Z",
    fill: "url(#paint4_radial_4249_4390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-25.4027 -66.2882L180.77 179.757L1.27655 -105H-25.4027V-66.2882Z",
    fill: "url(#paint5_radial_4249_4390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.403 32.2168L180.77 179.757L395.403 68.7706V32.2168Z",
    fill: "url(#paint6_radial_4249_4390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.645 -105H223.854L180.77 179.757L266.645 -105Z",
    fill: "url(#paint7_radial_4249_4390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8561 -105H42.2997L180.77 179.757L88.8561 -105Z",
    fill: "url(#paint8_radial_4249_4390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.403 94.1333L180.77 179.754L395.403 122.921V94.1333Z",
    fill: "url(#paint9_radial_4249_4390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-25.4027 120.886L180.77 179.759L-25.4027 91.1768V120.886Z",
    fill: "url(#paint10_radial_4249_4390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.922 -105H302.903L180.77 179.757L352.922 -105Z",
    fill: "url(#paint11_radial_4249_4390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-25.4027 15.9187L180.77 179.758L-25.4027 -33.0771V15.9187Z",
    fill: "url(#paint12_radial_4249_4390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.403 -41.813L180.77 179.756L395.403 9.19428V-41.813Z",
    fill: "url(#paint13_radial_4249_4390)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.456 -161.868L181.879 122.889L202.414 -161.868H171.456Z",
    fill: "url(#paint14_radial_4249_4390)"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86 84C100.083 84 111.5 72.5833 111.5 58.5C111.5 44.4167 100.083 33 86 33C71.9167 33 60.5 44.4167 60.5 58.5C60.5 72.5833 71.9167 84 86 84Z",
    fill: "#F4900C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86 81C100.083 81 111.5 69.5833 111.5 55.5C111.5 41.4167 100.083 30 86 30C71.9167 30 60.5 41.4167 60.5 55.5C60.5 69.5833 71.9167 81 86 81Z",
    fill: "#FFCC4D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86 78C97.598 78 107 68.598 107 57C107 45.402 97.598 36 86 36C74.402 36 65 45.402 65 57C65 68.598 74.402 78 86 78Z",
    fill: "#FFE8B6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86 76.5C97.598 76.5 107 67.098 107 55.5C107 43.902 97.598 34.5 86 34.5C74.402 34.5 65 43.902 65 55.5C65 67.098 74.402 76.5 86 76.5Z",
    fill: "#FFAC33"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.4675 42.7378C88.2203 41.8348 89.6866 42.4519 89.5675 43.6216L88.7265 51.8383H95.5293C95.7557 51.8384 95.9773 51.903 96.1683 52.0245C96.3593 52.146 96.5117 52.3194 96.6076 52.5244C96.7036 52.7293 96.7392 52.9574 96.7103 53.1819C96.6813 53.4064 96.589 53.618 96.4442 53.7919L84.5324 68.086C83.7796 68.9889 82.3132 68.3719 82.4324 67.2021L83.2733 58.9854H76.4705C76.2442 58.9853 76.0225 58.9207 75.8316 58.7993C75.6406 58.6778 75.4882 58.5044 75.3922 58.2994C75.2962 58.0944 75.2606 57.8663 75.2896 57.6419C75.3185 57.4174 75.4108 57.2058 75.5557 57.0319L87.4675 42.7378Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M276 54C290.083 54 301.5 42.5833 301.5 28.5C301.5 14.4167 290.083 3 276 3C261.917 3 250.5 14.4167 250.5 28.5C250.5 42.5833 261.917 54 276 54Z",
    fill: "#F4900C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M276 51C290.083 51 301.5 39.5833 301.5 25.5C301.5 11.4167 290.083 0 276 0C261.917 0 250.5 11.4167 250.5 25.5C250.5 39.5833 261.917 51 276 51Z",
    fill: "#FFCC4D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M276 48C287.598 48 297 38.598 297 27C297 15.402 287.598 6 276 6C264.402 6 255 15.402 255 27C255 38.598 264.402 48 276 48Z",
    fill: "#FFE8B6"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M276 46.5C287.598 46.5 297 37.098 297 25.5C297 13.902 287.598 4.5 276 4.5C264.402 4.5 255 13.902 255 25.5C255 37.098 264.402 46.5 276 46.5Z",
    fill: "#FFAC33"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M277.467 12.7378C278.22 11.8348 279.687 12.4519 279.568 13.6216L278.727 21.8383H285.529C285.756 21.8384 285.977 21.903 286.168 22.0245C286.359 22.146 286.512 22.3194 286.608 22.5244C286.704 22.7293 286.739 22.9574 286.71 23.1819C286.681 23.4064 286.589 23.618 286.444 23.7919L274.532 38.086C273.78 38.9889 272.313 38.3719 272.432 37.2021L273.273 28.9854H266.471C266.244 28.9853 266.023 28.9207 265.832 28.7993C265.641 28.6778 265.488 28.5044 265.392 28.2994C265.296 28.0944 265.261 27.8663 265.29 27.6419C265.319 27.4174 265.411 27.2058 265.556 27.0319L277.467 12.7378Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4249_4390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332 94.9998C339.824 94.9998 346.167 88.6572 346.167 80.8332C346.167 73.0091 339.824 66.6665 332 66.6665C324.176 66.6665 317.833 73.0091 317.833 80.8332C317.833 88.6572 324.176 94.9998 332 94.9998Z",
    fill: "#F4900C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332 93.3333C339.824 93.3333 346.167 86.9907 346.167 79.1667C346.167 71.3426 339.824 65 332 65C324.176 65 317.833 71.3426 317.833 79.1667C317.833 86.9907 324.176 93.3333 332 93.3333Z",
    fill: "#FFCC4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332 91.6668C338.443 91.6668 343.667 86.4435 343.667 80.0002C343.667 73.5568 338.443 68.3335 332 68.3335C325.557 68.3335 320.333 73.5568 320.333 80.0002C320.333 86.4435 325.557 91.6668 332 91.6668Z",
    fill: "#FFE8B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332 90.8333C338.443 90.8333 343.667 85.61 343.667 79.1667C343.667 72.7233 338.443 67.5 332 67.5C325.557 67.5 320.333 72.7233 320.333 79.1667C320.333 85.61 325.557 90.8333 332 90.8333Z",
    fill: "#FFAC33"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332.815 72.0765C333.234 71.5749 334.048 71.9177 333.982 72.5675L333.515 77.1324H337.294C337.42 77.1324 337.543 77.1683 337.649 77.2358C337.755 77.3033 337.84 77.3996 337.893 77.5135C337.947 77.6274 337.966 77.7541 337.95 77.8788C337.934 78.0035 337.883 78.121 337.802 78.2177L331.185 86.1588C330.767 86.6604 329.952 86.3177 330.018 85.6678L330.485 81.1029H326.706C326.58 81.1029 326.457 81.067 326.351 80.9995C326.245 80.932 326.16 80.8357 326.107 80.7218C326.054 80.608 326.034 80.4812 326.05 80.3565C326.066 80.2318 326.117 80.1143 326.198 80.0177L332.815 72.0765Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4249_4390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.4999 127C40.9767 127 45.4166 122.56 45.4166 117.083C45.4166 111.606 40.9767 107.167 35.4999 107.167C30.0231 107.167 25.5833 111.606 25.5833 117.083C25.5833 122.56 30.0231 127 35.4999 127Z",
    fill: "#F4900C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4999 125.833C40.9767 125.833 45.4166 121.393 45.4166 115.917C45.4166 110.44 40.9767 106 35.4999 106C30.0231 106 25.5833 110.44 25.5833 115.917C25.5833 121.393 30.0231 125.833 35.4999 125.833Z",
    fill: "#FFCC4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4999 124.667C40.0102 124.667 43.6666 121.01 43.6666 116.5C43.6666 111.99 40.0102 108.333 35.4999 108.333C30.9896 108.333 27.3333 111.99 27.3333 116.5C27.3333 121.01 30.9896 124.667 35.4999 124.667Z",
    fill: "#FFE8B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4999 124.083C40.0102 124.083 43.6666 120.427 43.6666 115.917C43.6666 111.406 40.0102 107.75 35.4999 107.75C30.9896 107.75 27.3333 111.406 27.3333 115.917C27.3333 120.427 30.9896 124.083 35.4999 124.083Z",
    fill: "#FFAC33"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0707 110.954C36.3635 110.603 36.9337 110.843 36.8874 111.297L36.5603 114.493H39.2059C39.2939 114.493 39.3801 114.518 39.4544 114.565C39.5286 114.612 39.5879 114.68 39.6252 114.76C39.6626 114.839 39.6764 114.928 39.6651 115.015C39.6539 115.103 39.618 115.185 39.5616 115.253L34.9293 120.811C34.6365 121.162 34.0663 120.923 34.1126 120.468L34.4397 117.272H31.7941C31.7061 117.272 31.6199 117.247 31.5456 117.2C31.4714 117.153 31.4121 117.085 31.3748 117.005C31.3374 116.926 31.3236 116.837 31.3349 116.75C31.3461 116.662 31.382 116.58 31.4384 116.513L36.0707 110.954Z",
    fill: "white"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M218.129 57.126C217.429 57.126 216.794 56.9627 216.225 56.636C215.665 56.3094 215.217 55.866 214.881 55.306C214.554 54.746 214.391 54.1207 214.391 53.43C214.391 52.7487 214.549 52.1327 214.867 51.582C215.184 51.022 215.613 50.5787 216.155 50.252C216.696 49.916 217.298 49.748 217.961 49.748C218.623 49.748 219.211 49.916 219.725 50.252C220.238 50.5787 220.644 51.0267 220.943 51.596C221.251 52.156 221.405 52.7907 221.405 53.5V53.892H215.791C215.865 54.284 216.01 54.634 216.225 54.942C216.449 55.25 216.729 55.4927 217.065 55.67C217.41 55.8474 217.783 55.936 218.185 55.936C218.53 55.936 218.861 55.8847 219.179 55.782C219.505 55.67 219.776 55.5114 219.991 55.306L220.887 56.188C220.467 56.5054 220.033 56.7434 219.585 56.902C219.146 57.0514 218.661 57.126 218.129 57.126ZM215.805 52.842H220.019C219.963 52.4687 219.832 52.142 219.627 51.862C219.431 51.5727 219.183 51.3487 218.885 51.19C218.595 51.022 218.278 50.938 217.933 50.938C217.578 50.938 217.251 51.0174 216.953 51.176C216.654 51.3347 216.402 51.5587 216.197 51.848C216.001 52.128 215.87 52.4594 215.805 52.842Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M210.963 57.1259C210.282 57.1259 209.661 56.9626 209.101 56.6359C208.541 56.3092 208.098 55.8659 207.771 55.3059C207.454 54.7459 207.295 54.1206 207.295 53.4299C207.295 52.7392 207.458 52.1186 207.785 51.5679C208.112 51.0079 208.55 50.5646 209.101 50.2379C209.661 49.9019 210.282 49.7339 210.963 49.7339C211.504 49.7339 212.022 49.8366 212.517 50.0419C213.021 50.2472 213.455 50.5366 213.819 50.9099L212.951 51.8759C212.68 51.5772 212.377 51.3532 212.041 51.2039C211.705 51.0546 211.355 50.9799 210.991 50.9799C210.562 50.9799 210.17 51.0872 209.815 51.3019C209.47 51.5166 209.194 51.8106 208.989 52.1839C208.784 52.5572 208.681 52.9726 208.681 53.4299C208.681 53.8872 208.784 54.3026 208.989 54.6759C209.194 55.0492 209.474 55.3479 209.829 55.5719C210.184 55.7866 210.58 55.8939 211.019 55.8939C211.383 55.8939 211.724 55.8239 212.041 55.6839C212.358 55.5346 212.657 55.3199 212.937 55.0399L213.791 55.9359C213.418 56.3186 212.984 56.6126 212.489 56.8179C212.004 57.0232 211.495 57.1259 210.963 57.1259Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M199.674 56.9999V49.8739H201.074V50.6019C201.624 50.0232 202.338 49.7339 203.216 49.7339C203.766 49.7339 204.247 49.8506 204.658 50.0839C205.078 50.3172 205.404 50.6439 205.638 51.0639C205.88 51.4839 206.002 51.9692 206.002 52.5199V56.9999H204.602V52.7579C204.602 52.1979 204.443 51.7592 204.126 51.4419C203.818 51.1152 203.384 50.9519 202.824 50.9519C202.45 50.9519 202.114 51.0312 201.816 51.1899C201.517 51.3486 201.27 51.5772 201.074 51.8759V56.9999H199.674Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M194.476 57.1259C193.963 57.1259 193.51 57.0372 193.118 56.8599C192.726 56.6732 192.418 56.4166 192.194 56.0899C191.97 55.7632 191.858 55.3852 191.858 54.9559C191.858 54.2839 192.115 53.7566 192.628 53.3739C193.142 52.9819 193.846 52.7859 194.742 52.7859C195.442 52.7859 196.091 52.9212 196.688 53.1919V52.4359C196.688 51.9226 196.539 51.5399 196.24 51.2879C195.951 51.0359 195.522 50.9099 194.952 50.9099C194.626 50.9099 194.285 50.9612 193.93 51.0639C193.576 51.1572 193.179 51.3066 192.74 51.5119L192.222 50.4619C192.764 50.2099 193.268 50.0279 193.734 49.9159C194.201 49.7946 194.672 49.7339 195.148 49.7339C196.072 49.7339 196.786 49.9532 197.29 50.3919C197.804 50.8306 198.06 51.4559 198.06 52.2679V56.9999H196.688V56.3839C196.371 56.6359 196.03 56.8226 195.666 56.9439C195.302 57.0652 194.906 57.1259 194.476 57.1259ZM193.202 54.9279C193.202 55.2732 193.347 55.5532 193.636 55.7679C193.935 55.9732 194.322 56.0759 194.798 56.0759C195.172 56.0759 195.512 56.0246 195.82 55.9219C196.138 55.8099 196.427 55.6372 196.688 55.4039V54.1999C196.418 54.0412 196.133 53.9292 195.834 53.8639C195.545 53.7892 195.218 53.7519 194.854 53.7519C194.341 53.7519 193.935 53.8592 193.636 54.0739C193.347 54.2792 193.202 54.5639 193.202 54.9279Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M189.174 57.0001V47.2001L190.574 46.9341V57.0001H189.174Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M183.976 57.1259C183.463 57.1259 183.01 57.0372 182.618 56.8599C182.226 56.6732 181.918 56.4166 181.694 56.0899C181.47 55.7632 181.358 55.3852 181.358 54.9559C181.358 54.2839 181.615 53.7566 182.128 53.3739C182.642 52.9819 183.346 52.7859 184.242 52.7859C184.942 52.7859 185.591 52.9212 186.188 53.1919V52.4359C186.188 51.9226 186.039 51.5399 185.74 51.2879C185.451 51.0359 185.022 50.9099 184.452 50.9099C184.126 50.9099 183.785 50.9612 183.43 51.0639C183.076 51.1572 182.679 51.3066 182.24 51.5119L181.722 50.4619C182.264 50.2099 182.768 50.0279 183.234 49.9159C183.701 49.7946 184.172 49.7339 184.648 49.7339C185.572 49.7339 186.286 49.9532 186.79 50.3919C187.304 50.8306 187.56 51.4559 187.56 52.2679V56.9999H186.188V56.3839C185.871 56.6359 185.53 56.8226 185.166 56.9439C184.802 57.0652 184.406 57.1259 183.976 57.1259ZM182.702 54.9279C182.702 55.2732 182.847 55.5532 183.136 55.7679C183.435 55.9732 183.822 56.0759 184.298 56.0759C184.672 56.0759 185.012 56.0246 185.32 55.9219C185.638 55.8099 185.927 55.6372 186.188 55.4039V54.1999C185.918 54.0412 185.633 53.9292 185.334 53.8639C185.045 53.7892 184.718 53.7519 184.354 53.7519C183.841 53.7519 183.435 53.8592 183.136 54.0739C182.847 54.2792 182.702 54.5639 182.702 54.9279Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M172.498 57.0002V47.2002H176.74C177.384 47.2002 177.944 47.3075 178.42 47.5222C178.896 47.7369 179.264 48.0402 179.526 48.4322C179.787 48.8149 179.918 49.2675 179.918 49.7902C179.918 50.2662 179.796 50.6862 179.554 51.0502C179.311 51.4142 178.97 51.7035 178.532 51.9182C179.082 52.1142 179.512 52.4129 179.82 52.8142C180.137 53.2062 180.296 53.6682 180.296 54.2002C180.296 54.7695 180.156 55.2642 179.876 55.6842C179.605 56.1042 179.213 56.4309 178.7 56.6642C178.196 56.8882 177.603 57.0002 176.922 57.0002H172.498ZM173.968 51.3582H176.656C177.206 51.3582 177.645 51.2275 177.972 50.9662C178.298 50.7049 178.462 50.3502 178.462 49.9022C178.462 49.4542 178.298 49.0995 177.972 48.8382C177.645 48.5769 177.206 48.4462 176.656 48.4462H173.968V51.3582ZM173.968 55.7542H176.81C177.426 55.7542 177.911 55.6095 178.266 55.3202C178.63 55.0309 178.812 54.6389 178.812 54.1442C178.812 53.6589 178.63 53.2715 178.266 52.9822C177.911 52.6835 177.426 52.5342 176.81 52.5342H173.968V55.7542Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M162.361 60.01C162.211 60.01 162.071 60.0007 161.941 59.982C161.81 59.9727 161.703 59.954 161.619 59.926V58.694C161.787 58.7314 161.992 58.75 162.235 58.75C162.888 58.75 163.359 58.4 163.649 57.7L163.957 57.014L161.101 49.874H162.655L164.727 55.306L167.023 49.874H168.535L165.091 57.882C164.867 58.386 164.629 58.792 164.377 59.1C164.125 59.4174 163.835 59.646 163.509 59.786C163.182 59.9354 162.799 60.01 162.361 60.01Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M149.994 57.0002V47.2002H151.968L155.034 53.4722L158.1 47.2002H160.06V57.0002H158.674V48.9922L155.02 56.3002L151.366 48.9922V57.0002H149.994Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_4249_4390",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 119,
    width: 82,
    height: 42
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 119,
    width: 82,
    height: 42,
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_4249_4390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.415 165.148L171.093 165.377L171.041 165.365L163.769 163.76L159.831 162.89L154.985 161.821L154.239 158.306L153.281 153.805L148.921 133.328C148.83 132.907 149.098 132.491 149.52 132.401L172.424 127.526L175.905 126.785L185.583 124.725L190.042 123.777H190.045L193.644 123.009C194.065 122.918 194.481 123.186 194.571 123.608L194.851 124.924L195.303 127.047L201 153.805L201.958 158.306L203.415 165.148Z",
    fill: "#1EBC61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.076 165.527L171.007 165.511L154.858 161.946L153.134 153.836L148.773 133.36C148.666 132.857 148.987 132.361 149.489 132.253L190.042 123.626L193.612 122.861C194.115 122.755 194.611 123.075 194.718 123.576L203.601 165.297L203.416 165.299L171.076 165.527ZM155.113 161.694L171.11 165.226L203.23 164.999L194.424 123.639C194.389 123.475 194.292 123.334 194.15 123.243C194.009 123.151 193.84 123.119 193.675 123.156L149.551 132.548C149.212 132.621 148.995 132.957 149.068 133.297L155.113 161.694Z",
    fill: "#66142E"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.55
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.734 124.367L192.039 124.942H192.036L177.901 127.95L151.517 133.566C151.095 133.656 150.824 134.072 150.915 134.494L155.278 154.97L156.235 159.472L156.817 162.224L154.986 161.821L154.239 158.306L153.281 153.805L148.921 133.328C148.831 132.907 149.099 132.491 149.52 132.401L175.905 126.785L190.043 123.777H190.046L193.644 123.009C194.066 122.918 194.481 123.186 194.571 123.608L194.734 124.367Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M198.796 165.148L171.042 165.365L159.831 162.89L158.855 158.307L157.898 153.805L154.974 140.068C157.196 139.595 158.614 137.409 158.141 135.183L174.742 131.651L186.905 129.062C187.378 131.284 189.564 132.702 191.789 132.229L196.381 153.805L197.339 158.307L198.796 165.148Z",
    fill: "#4EEC91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.026 165.515L171.009 165.512L159.704 163.016L157.75 153.836L154.795 139.952L154.942 139.92C157.08 139.466 158.449 137.355 157.994 135.214L157.963 135.067L158.11 135.036L187.021 128.883L187.052 129.03C187.507 131.168 189.619 132.536 191.758 132.082L191.905 132.051L191.936 132.198L198.982 165.297L171.026 165.515ZM159.958 162.764L171.058 165.214L198.61 164.999L191.673 132.405C189.472 132.797 187.332 131.406 186.791 129.24L158.317 135.3C158.706 137.501 157.319 139.64 155.152 140.181L159.958 162.764Z",
    fill: "#66142E"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.415 165.148L171.093 165.377L171.041 165.365L163.769 163.76L172.424 127.526L175.905 126.785L185.583 124.725L195.303 127.047L201 153.805L201.958 158.306L203.415 165.148Z",
    fill: "#66142E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M203.415 166.052C202.997 166.052 202.622 165.761 202.532 165.336L193.714 123.918L190.234 124.66C190.223 124.662 190.211 124.664 190.2 124.666L149.83 133.259L156.077 162.602C156.181 163.09 155.869 163.57 155.381 163.674C154.893 163.777 154.414 163.466 154.31 162.978L148.037 133.516C147.843 132.609 148.423 131.712 149.331 131.517L189.854 122.893C189.865 122.89 189.876 122.888 189.887 122.887L193.455 122.125C193.894 122.031 194.345 122.114 194.722 122.357C195.1 122.602 195.361 122.978 195.455 123.419L204.299 164.96C204.403 165.448 204.092 165.927 203.604 166.032C203.54 166.045 203.477 166.052 203.415 166.052Z",
    fill: "#66142E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.795 165.901C198.448 165.901 198.135 165.659 198.06 165.305L191.197 133.065C189.092 133.183 187.133 131.911 186.382 129.943L158.977 135.775C159.093 137.881 157.823 139.839 155.854 140.59L160.775 163.702C160.862 164.109 160.602 164.509 160.195 164.596C159.789 164.681 159.389 164.423 159.302 164.016L154.237 140.224C154.196 140.029 154.233 139.825 154.342 139.658C154.451 139.49 154.622 139.373 154.817 139.331C156.63 138.945 157.791 137.155 157.405 135.34C157.319 134.933 157.578 134.533 157.985 134.447L186.748 128.325C186.943 128.285 187.147 128.321 187.315 128.43C187.482 128.539 187.599 128.71 187.641 128.905C188.027 130.717 189.817 131.879 191.633 131.493C192.04 131.406 192.439 131.666 192.525 132.073L199.533 164.991C199.619 165.398 199.36 165.798 198.953 165.885C198.9 165.896 198.847 165.901 198.795 165.901Z",
    fill: "#66142E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.564 132.349L217.872 151.985L214.729 165.148H166.741L177.166 121.503C177.266 121.084 177.687 120.825 178.109 120.925L221.986 131.407C222.404 131.506 222.663 131.928 222.564 132.349Z",
    fill: "#1EBC61"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.55
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.564 132.349L222.344 133.268L179.413 123.011C178.991 122.912 178.57 123.171 178.47 123.589L168.545 165.148H166.741L177.166 121.503C177.266 121.084 177.687 120.825 178.109 120.925L221.986 131.407C222.404 131.506 222.663 131.928 222.564 132.349Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M214.729 166.051H166.742C166.465 166.051 166.204 165.924 166.032 165.707C165.861 165.49 165.799 165.207 165.863 164.938L176.288 121.293C176.502 120.392 177.411 119.832 178.316 120.045L222.196 130.528C223.096 130.742 223.656 131.652 223.443 132.557C223.443 132.558 223.443 132.559 223.443 132.559L215.607 165.358C215.51 165.764 215.147 166.051 214.729 166.051ZM167.886 164.244H214.016L221.657 132.257L178.017 121.832L167.886 164.244Z",
    fill: "#66142E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.346 138.935L210.082 165.148H171.385L179.735 130.19C181.948 130.717 184.167 129.353 184.694 127.143L213.298 133.976C212.771 136.186 214.135 138.408 216.346 138.935Z",
    fill: "#4EEC91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.364 151.238C188.595 150.136 183.026 153.919 181.924 159.688C181.563 161.58 181.73 163.449 182.317 165.148H202.421C202.583 164.674 202.716 164.184 202.813 163.678C203.915 157.909 200.132 152.34 194.364 151.238Z",
    fill: "#1EBC61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.512 143.019C198.184 143.019 199.54 141.664 199.54 139.992C199.54 138.319 198.184 136.964 196.512 136.964C194.84 136.964 193.484 138.319 193.484 139.992C193.484 141.664 194.84 143.019 196.512 143.019Z",
    fill: "#1EBC61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.082 165.901H171.385C171.154 165.901 170.937 165.795 170.794 165.614C170.651 165.433 170.599 165.197 170.652 164.973L179.003 130.015C179.099 129.611 179.505 129.361 179.909 129.458C181.713 129.886 183.532 128.771 183.962 126.968C184.008 126.774 184.13 126.606 184.3 126.502C184.47 126.397 184.675 126.364 184.869 126.411L213.473 133.243C213.877 133.34 214.127 133.746 214.03 134.15C213.6 135.955 214.717 137.773 216.52 138.203C216.714 138.249 216.882 138.37 216.987 138.541C217.091 138.711 217.124 138.915 217.078 139.11L210.814 165.323C210.733 165.662 210.43 165.901 210.082 165.901ZM172.338 164.395H209.488L215.452 139.436C213.501 138.637 212.28 136.648 212.448 134.546L185.195 128.037C184.396 129.986 182.407 131.209 180.306 131.04L172.338 164.395Z",
    fill: "#66142E"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_4249_4390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9999 55.9998C32.1727 55.9998 35.5554 52.617 35.5554 48.4442C35.5554 44.2714 32.1727 40.8887 27.9999 40.8887C23.8271 40.8887 20.4443 44.2714 20.4443 48.4442C20.4443 52.617 23.8271 55.9998 27.9999 55.9998Z",
    fill: "#F4900C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9999 55.1111C32.1727 55.1111 35.5554 51.7284 35.5554 47.5556C35.5554 43.3827 32.1727 40 27.9999 40C23.8271 40 20.4443 43.3827 20.4443 47.5556C20.4443 51.7284 23.8271 55.1111 27.9999 55.1111Z",
    fill: "#FFCC4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0001 54.2223C31.4365 54.2223 34.2223 51.4365 34.2223 48.0001C34.2223 44.5636 31.4365 41.7778 28.0001 41.7778C24.5636 41.7778 21.7778 44.5636 21.7778 48.0001C21.7778 51.4365 24.5636 54.2223 28.0001 54.2223Z",
    fill: "#FFE8B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0001 53.7779C31.4365 53.7779 34.2223 50.9922 34.2223 47.5557C34.2223 44.1193 31.4365 41.3335 28.0001 41.3335C24.5636 41.3335 21.7778 44.1193 21.7778 47.5557C21.7778 50.9922 24.5636 53.7779 28.0001 53.7779Z",
    fill: "#FFAC33"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4349 43.774C28.658 43.5065 29.0924 43.6893 29.0571 44.0359L28.808 46.4705H30.8236C30.8907 46.4705 30.9563 46.4897 31.0129 46.5256C31.0695 46.5616 31.1147 46.613 31.1431 46.6738C31.1715 46.7345 31.1821 46.8021 31.1735 46.8686C31.1649 46.9351 31.1376 46.9978 31.0947 47.0493L27.5652 51.2846C27.3422 51.5521 26.9077 51.3693 26.943 51.0227L27.1922 48.5881H25.1765C25.1095 48.5881 25.0438 48.569 24.9872 48.533C24.9306 48.497 24.8855 48.4456 24.857 48.3849C24.8286 48.3241 24.8181 48.2566 24.8266 48.1901C24.8352 48.1235 24.8626 48.0608 24.9055 48.0093L28.4349 43.774Z",
    fill: "white"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M147.125 127.375L145.358 131.857L140.875 133.625L145.358 135.392L147.125 139.875L148.893 135.392L153.375 133.625L148.893 131.857L147.125 127.375Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M147.125 126.749C146.87 126.749 146.637 126.907 146.544 127.146L144.876 131.375L140.646 133.043C140.53 133.09 140.43 133.17 140.359 133.274C140.289 133.377 140.252 133.5 140.252 133.625C140.252 133.75 140.289 133.872 140.359 133.976C140.43 134.08 140.53 134.16 140.646 134.206L144.876 135.874L146.544 140.104C146.59 140.22 146.67 140.32 146.774 140.391C146.878 140.461 147 140.498 147.125 140.498C147.25 140.498 147.373 140.461 147.476 140.391C147.58 140.32 147.66 140.22 147.707 140.104L149.375 135.874L153.605 134.206C153.721 134.16 153.821 134.08 153.891 133.976C153.961 133.872 153.999 133.75 153.999 133.625C153.999 133.5 153.961 133.377 153.891 133.274C153.821 133.17 153.721 133.09 153.605 133.043L149.375 131.375L147.707 127.146C147.66 127.029 147.58 126.929 147.476 126.859C147.372 126.788 147.25 126.75 147.125 126.749ZM147.125 129.079L148.311 132.085C148.343 132.165 148.39 132.237 148.451 132.298C148.512 132.358 148.584 132.406 148.664 132.437L151.671 133.622L148.664 134.81C148.584 134.842 148.512 134.889 148.451 134.95C148.391 135.01 148.343 135.082 148.311 135.161L147.126 138.17L145.938 135.161C145.906 135.082 145.859 135.01 145.799 134.95C145.738 134.89 145.666 134.842 145.587 134.81L142.578 133.624L145.587 132.437C145.666 132.406 145.738 132.358 145.799 132.297C145.859 132.237 145.906 132.165 145.938 132.085L147.125 129.079ZM152.75 125.5L151.955 127.204L150.251 127.999L151.955 128.795L152.75 130.499L153.544 128.795L155.25 128L153.546 127.206L152.75 125.5Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M332.166 35.5L329.81 41.476L323.834 43.834L329.81 46.19L332.166 52.166L334.524 46.19L340.5 43.834L334.524 41.476L332.166 35.5Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M332.166 34.666C331.826 34.666 331.516 34.876 331.392 35.194L329.168 40.834L323.528 43.058C323.373 43.1197 323.24 43.2265 323.146 43.3647C323.052 43.5029 323.002 43.666 323.002 43.833C323.002 44 323.052 44.1631 323.146 44.3013C323.24 44.4395 323.373 44.5463 323.528 44.608L329.168 46.832L331.392 52.472C331.454 52.6272 331.561 52.7602 331.699 52.854C331.837 52.9478 332 52.9979 332.167 52.9979C332.334 52.9979 332.497 52.9478 332.635 52.854C332.773 52.7602 332.88 52.6272 332.942 52.472L335.166 46.832L340.806 44.608C340.961 44.5463 341.094 44.4395 341.188 44.3013C341.282 44.1631 341.332 44 341.332 43.833C341.332 43.666 341.282 43.5029 341.188 43.3647C341.094 43.2265 340.961 43.1197 340.806 43.058L335.166 40.834L332.942 35.194C332.88 35.0388 332.773 34.9056 332.635 34.8115C332.496 34.7174 332.333 34.6668 332.166 34.666ZM332.166 37.772L333.748 41.78C333.79 41.8862 333.854 41.9827 333.935 42.0635C334.015 42.1443 334.112 42.2078 334.218 42.25L338.228 43.83L334.218 45.414C334.112 45.456 334.016 45.5192 333.935 45.5996C333.854 45.6801 333.79 45.7762 333.748 45.882L332.168 49.894L330.584 45.882C330.542 45.7764 330.478 45.6804 330.398 45.6C330.318 45.5195 330.222 45.4562 330.116 45.414L326.104 43.832L330.116 42.25C330.222 42.2075 330.318 42.144 330.398 42.0631C330.479 41.9823 330.542 41.886 330.584 41.78L332.166 37.772ZM339.666 33L338.606 35.272L336.334 36.332L338.606 37.394L339.666 39.666L340.726 37.394L343 36.334L340.728 35.274L339.666 33Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1141 77.8438L20.4944 81.9523L16.3859 83.5734L20.4944 85.1931L22.1141 89.3016L23.7352 85.1931L27.8438 83.5734L23.7352 81.9523L22.1141 77.8438Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1141 77.2704C21.8804 77.2704 21.6673 77.4148 21.582 77.6334L20.053 81.5109L16.1755 83.0399C16.0688 83.0823 15.9773 83.1557 15.9129 83.2507C15.8484 83.3457 15.814 83.4579 15.814 83.5727C15.814 83.6875 15.8484 83.7996 15.9129 83.8946C15.9773 83.9896 16.0688 84.0631 16.1755 84.1055L20.053 85.6345L21.582 89.512C21.6244 89.6187 21.6979 89.7102 21.7929 89.7746C21.8879 89.8391 22 89.8735 22.1148 89.8735C22.2296 89.8735 22.3418 89.8391 22.4368 89.7746C22.5318 89.7102 22.6052 89.6187 22.6476 89.512L24.1766 85.6345L28.0541 84.1055C28.1608 84.0631 28.2523 83.9896 28.3168 83.8946C28.3812 83.7996 28.4157 83.6875 28.4157 83.5727C28.4157 83.4579 28.3812 83.3457 28.3168 83.2507C28.2523 83.1557 28.1608 83.0823 28.0541 83.0399L24.1766 81.5109L22.6476 77.6334C22.6049 77.5266 22.5313 77.4351 22.4363 77.3704C22.3413 77.3057 22.2291 77.2709 22.1141 77.2704ZM22.1141 79.4058L23.2018 82.1612C23.2308 82.2343 23.2744 82.3006 23.33 82.3561C23.3856 82.4117 23.4519 82.4553 23.5249 82.4844L26.2817 83.5706L23.5249 84.6596C23.452 84.6885 23.3858 84.7319 23.3302 84.7873C23.2747 84.8426 23.231 84.9086 23.2018 84.9814L22.1155 87.7396L21.0265 84.9814C20.9975 84.9088 20.954 84.8428 20.8986 84.7875C20.8433 84.7322 20.7774 84.6887 20.7047 84.6596L17.9465 83.572L20.7047 82.4844C20.7775 82.4552 20.8436 82.4115 20.8989 82.3559C20.9542 82.3004 20.9976 82.2341 21.0265 82.1612L22.1141 79.4058ZM27.2704 76.125L26.5416 77.687L24.9796 78.4157L26.5416 79.1459L27.2704 80.7079L27.9991 79.1459L29.5625 78.4171L28.0005 77.6884L27.2704 76.125Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M235.865 130.906L237.779 135.762L242.635 137.678L237.779 139.592L235.865 144.447L233.949 139.592L229.094 137.678L233.949 135.762L235.865 130.906Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M235.865 130.229C236.141 130.229 236.393 130.399 236.494 130.658L238.301 135.24L242.883 137.047C243.01 137.097 243.118 137.184 243.194 137.296C243.27 137.409 243.311 137.541 243.311 137.677C243.311 137.812 243.27 137.945 243.194 138.057C243.118 138.17 243.01 138.256 242.883 138.306L238.301 140.113L236.494 144.696C236.444 144.822 236.357 144.93 236.245 145.006C236.133 145.083 236 145.123 235.864 145.123C235.729 145.123 235.596 145.083 235.484 145.006C235.372 144.93 235.285 144.822 235.235 144.696L233.428 140.113L228.845 138.306C228.719 138.256 228.611 138.17 228.535 138.057C228.459 137.945 228.418 137.812 228.418 137.677C228.418 137.541 228.459 137.409 228.535 137.296C228.611 137.184 228.719 137.097 228.845 137.047L233.428 135.24L235.235 130.658C235.285 130.531 235.372 130.423 235.484 130.347C235.597 130.27 235.729 130.229 235.865 130.229ZM235.865 132.752L234.58 136.009C234.545 136.095 234.494 136.173 234.428 136.239C234.363 136.305 234.284 136.356 234.198 136.391L230.94 137.674L234.198 138.961C234.284 138.996 234.362 139.047 234.428 139.112C234.494 139.178 234.545 139.256 234.58 139.342L235.863 142.601L237.15 139.342C237.185 139.256 237.236 139.178 237.302 139.112C237.367 139.047 237.445 138.996 237.531 138.961L240.79 137.676L237.531 136.391C237.445 136.356 237.367 136.304 237.301 136.239C237.236 136.173 237.185 136.095 237.15 136.009L235.865 132.752ZM229.771 128.875L230.633 130.721L232.479 131.582L230.633 132.445L229.771 134.291L228.91 132.445L227.062 131.584L228.908 130.723L229.771 128.875Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4249_4390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(177.45 187.852) rotate(-77.2934) scale(243.177 266.154)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#169560"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4249_4390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.975 176.572) rotate(-77.2934) scale(243.233 266.215)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#169560"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_4249_4390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.869 176.965) rotate(-77.2934) scale(241.297 264.096)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#169560"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_4249_4390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.914 176.935) rotate(-77.2934) scale(213.276 233.427)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#169560"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_4249_4390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(180.003 176.577) rotate(-77.2934) scale(242.419 265.324)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#169560"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_4249_4390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.975 176.572) rotate(-77.2934) scale(243.226 266.207)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#169560"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_4249_4390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.975 176.571) rotate(-77.2934) scale(243.236 266.218)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#169560"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_4249_4390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.963 176.569) rotate(-77.2934) scale(243.237 266.219)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#169560"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_4249_4390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(182.252 182.734) rotate(90) scale(242.176 267.382)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#169560"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_4249_4390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(182.252 182.731) rotate(90) scale(242.176 267.382)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#169560"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_4249_4390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(182.252 182.338) rotate(90) scale(242.168 267.373)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#169560"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_4249_4390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(182.252 182.734) rotate(90) scale(242.177 267.383)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#169560"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_4249_4390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(182.252 182.735) rotate(90) scale(242.176 267.382)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#169560"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_4249_4390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(182.252 182.733) rotate(90) scale(242.17 267.375)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#169560"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_4249_4390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(188.052 125.866) rotate(90) scale(184.059 203.216)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#169560"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4249_4390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(317 65)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4249_4390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(25 106)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_4249_4390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(20 40)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalancebg);
export default __webpack_public_path__ + "static/media/balancebg.312af816fb1e96d3b37460520b5d996d.svg";
export { ForwardRef as ReactComponent };